function delay(fn, ms) {
    let timer = 0
    return function(...args) {
        clearTimeout(timer)
        timer = setTimeout(fn.bind(this, ...args), ms || 0)
    }
}

jQuery( document ).ready(function() {
    // init datepicker
    comby_init_event_datepicker( jQuery(".comby-datepicker"), ".comby-datepicker:not('.comby-event-startdate')" );

    jQuery('.comby-add-date').click(function () {
        // get parent wrapper
        var entrywrapper = jQuery(this).parent().parent();
        // get current datecount
        var datecountidx = parseInt(jQuery('#comby_event_datecountidx_id').val());
        // get the clone item and create a new line
        var newline = entrywrapper.find('.comby-clone').clone();
        // remove the 'clone' class from the new line
        newline.removeClass('comby-clone');
        // add class 'comby-meta-box-repeater__line'
        newline.addClass('comby-meta-box-repeater__line');
        // replace the placeholder with the current index
        newline.html(newline.html().replace(/datecountidx/g, datecountidx));
        // get last date entry
        var lastdateentry = entrywrapper.find('table .comby-meta-box-repeater__line:last');
        // check dateformat (currently only dd.mm.yy is supported)
        if (lastdateentry.find('.comby-event-startdate').datepicker('option', 'dateFormat') == 'dd.mm.yy') {
            var startdate = lastdateentry.find('.comby-event-startdate').val().split('.');
            if (startdate.length == 3) {
                // set startdate of new entry to startdate of last entry + 7 days
                var startdatetimestamp = Date.parse(startdate[2] + '-' + startdate[1] + '-' + startdate[0]);
                var nextdate = new Date(startdatetimestamp + (7*24*60*60*1000));
                var nextdatestr = ('0' + nextdate.getDate()).slice(-2) + '.' + ('0' + (nextdate.getMonth() + 1)).slice(-2) + '.' + nextdate.getFullYear();
                // set dates of new dateentry
                newline.find('.comby-inputdate').val(nextdatestr);
            }
        }
        // set times from last entry
        newline.find('.comby-eventdate-starthour').val((lastdateentry.find('.comby-eventdate-starthour').val()));
        newline.find('.comby-eventdate-startminute').val((lastdateentry.find('.comby-eventdate-startminute').val()));
        newline.find('.comby-eventdate-endhour').val((lastdateentry.find('.comby-eventdate-endhour').val()));
        newline.find('.comby-eventdate-endminute').val((lastdateentry.find('.comby-eventdate-endminute').val()));
        newline.find('.comby-eventdate-entryhour').val((lastdateentry.find('.comby-eventdate-entryhour').val()));
        newline.find('.comby-eventdate-entryminute').val((lastdateentry.find('.comby-eventdate-entryminute').val()));
        // insert the new line
        newline.insertBefore(entrywrapper.find('.comby-meta-box-repeater table tr:last'));
        comby_init_event_datepicker(newline.find( ".comby-newdatepicker" ), ".comby-newdatepicker:not('.comby-event-startdate')");
        newline.find( ".comby-eventdate-delete" ).click(function () {
            // set 'deleted' flag to 1
            jQuery(this).parent().find('.comby-eventdate-deleted').val('1');
            // hide this line
            jQuery(this).parent().parent().remove();
        });
        // increment the datecount index for the next new line
        jQuery('#comby_event_datecountidx_id').val(++datecountidx);
    });

    jQuery('.comby-add-autostate').click(function () {
        // get parent wrapper
        var entrywrapper = jQuery(this).parent().parent();
        // get current datecount
        var statuscountidx = parseInt(jQuery('#comby_event_statuscountidx_id').val());
        // get the clone item and create a new line
        var newline = entrywrapper.find('.comby-clone').clone();
        // remove the 'clone' class from the new line
        newline.removeClass('comby-clone');
        // add class 'comby-meta-box-repeater__line'
        newline.addClass('comby-meta-box-repeater__line');
        // replace the placeholder with the current index
        newline.html(newline.html().replace(/statuscountidx/g, statuscountidx));
        // insert the new line
        newline.insertBefore(entrywrapper.find('.comby-meta-box-repeater table tr:last'));
        comby_init_event_datepicker(newline.find( ".comby-newdatepicker" ));
        newline.find( ".comby-autostate-delete" ).click(function () {
            // set 'deleted' flag to 1
            jQuery(this).parent().find('.comby-autostate-deleted').val('1');
            // hide this line
            jQuery(this).parent().parent().remove();
        });
        // increment the datecount index for the next new line
        jQuery('#comby_event_statuscountidx_id').val(++statuscountidx);
    });

    jQuery('.comby-eventdate-delete').click(function () {
        // set 'deleted' flag to 1
        jQuery(this).parent().find('.comby-eventdate-deleted').val('1');
        // hide this line
        jQuery(this).parent().parent().addClass('comby-hidden');
    });

    jQuery('.comby-autostate-delete').click(function () {
        // set 'deleted' flag to 1
        jQuery(this).parent().find('.comby-autostate-deleted').val('1');
        // hide this line
        jQuery(this).parent().parent().addClass('comby-hidden');
    });

    jQuery('.comby-form-placeholder').click(function () {
        var target = jQuery(this).data('target');
        var cursorPos = jQuery(target).prop('selectionStart');
        var v = jQuery(target).val();
        var textBefore = v.substring(0, cursorPos);
        var textAfter  = v.substring(cursorPos, v.length);
        var insertionText = jQuery(this).html();
        jQuery(target).val(textBefore + insertionText + textAfter);
        // set new cursor position
        var selectionText = jQuery(this).data('select');
        if (selectionText) {
            var selectionPos = insertionText.indexOf(selectionText);
            jQuery(target).prop('selectionStart', textBefore.length + selectionPos);
            jQuery(target).prop('selectionEnd', textBefore.length + selectionPos + selectionText.length);
        } else {
            jQuery(target).prop('selectionStart', textBefore.length + jQuery(this).html().length);
            jQuery(target).prop('selectionEnd', jQuery(target).prop('selectionStart'));
        }
        // focus textarea
        jQuery(target).focus();
    });

    jQuery('#comby_event_type_id').change(function () {
        comby_update_event_admin_page();
    });
    comby_update_event_admin_page();

    jQuery('.comby-submit').click(function (event) {
        // prevent browser from default page reload (but still force to remember form inputs for browsers autocomplete)
        event.preventDefault();
        // get form
        var form = jQuery(this).parents('form:first');
        // get data (before disabling inputs)
        var requestData = form.serialize();
        // hide 'required fields' note (to prevent from appearing when submit button is disabled while form will be sent)
        form.find('.comby-form-invalid-note').hide();
        // disable all inputs
        form.find('input, select, textarea, button').prop('disabled', true);
        // get parent div
        var regdiv = jQuery(this).parents('div.comby-registration:first');
        // post data
        jQuery.post(comby.ajaxurl, requestData, function(data) {
            var respdiv = regdiv.children('.comby-registration__response');
            try {
                var ret = JSON.parse(data);
                respdiv.html(ret.msg);
                if (ret.error != 0) {
                    respdiv.addClass('comby-registration__response--error');
                } else {
                    respdiv.addClass('comby-registration__response--success');
                }
            } catch (e) {
                // unknown error
                respdiv.addClass('comby-registration__response--error');
                respdiv.html(data);
            }
            form.parent().slideUp(350);
            respdiv.slideDown(300);
        });
    });
    jQuery('.comby-add-attendee').click(function () {
        // get form
        var form = jQuery(this).parents('form:first');
        var formid = form.find('input[name="fid"]').val();
        var eventid = form.find('input[name="eid"]').val();
        var maxattendees = parseInt(form.find('input[name="maxattendees"]').val());
        var attendeeswrapper = jQuery(form).find('.comby-attendees');
        var idx = attendeeswrapper.children('.comby-attendee').length;
        // get template for new attendee for this form
        var newattendeetemplate = '<div class="comby-attendee"><input type="text" class="comby-attendee__firstname" name="attendee[' +
        idx + '][firstname]"><input type="text" class="comby-attendee__lastname" name="attendee[' + idx + '][lastname]"></div>';
        jQuery.post(comby.ajaxurl, { action: 'comby_newattendeetemplate', fid: formid, eid: eventid, attidx: idx }, function(data) {
            newattendeetemplate = jQuery(data);
            attendeeswrapper.append(newattendeetemplate);
            var count = attendeeswrapper.children('.comby-attendee').length;
            if (maxattendees > 0 && (maxattendees-1) <= count)
                form.find('.comby-add-attendee').hide();
            newattendeetemplate.find('input, select').change(function () {
                comby_update_form_state();
            });
            newattendeetemplate.find('input').keyup(function () {
                comby_update_form_state();
            });
            comby_update_form_state();
        });
    });
    // hide 'add attendee' button initially if max attendees already reached
    jQuery('.comby-register-form').each(function (i) {
        var maxattendees = parseInt(jQuery(this).find('input[name="maxattendees"]').val());
        var attendeeswrapper = jQuery(this).find('.comby-attendees');
        var count = attendeeswrapper.children('.comby-attendee').length;
        if (maxattendees > 0 && (maxattendees-1) <= count)
            jQuery(this).find('.comby-add-attendee').hide();
    });

    // delete one registration entry for event
    jQuery('.comby-deleteregistration').click(function () {
        var rid = jQuery(this).data('regid');
        if (confirm(comby.textconfirmdeletereg)) {
            jQuery.post(comby.ajaxurl, { action: 'comby_deleteregistration', regid: rid }, function(data) {
                if (data == "") {
                    location.reload();
                } else {
                    alert(data);
                }
            });
        }
    });

    // confirm registration entry
    jQuery('.comby-confirmregistration').click(function () {
        var rid = jQuery(this).data('regid');
        var registrations = jQuery('.comby-confirmregistration[data-regid=' + rid + ']');
        jQuery.post(comby.ajaxurl, { action: 'comby_confirmregistration', regid: rid }, function(data) {
            if (data == "") {
                registrations.removeClass('comby-clickicon--bg-red comby-clickicon--state-ok');
                registrations.addClass('comby-clickicon--bg-green comby-clickicon--state-disabled');
                registrations.attr('title', '');
            } else {
                registrations.removeClass('comby-clickicon--bg-green comby-clickicon--state-disabled');
                registrations.addClass('comby-clickicon--bg-red comby-clickicon--state-ok');
                registrations.attr('title', data);
            }
        });
    });

    // save changes to registration entry
    jQuery('#submit-registration').click(function (e) {
        // get form
        var form = jQuery(this).parents('form:first');
        // get rid and timestamp
        var rid = form.find('input[name=regid]').val();
        var t = form.find('input[name=timestamp]').val();
        // get data (before disabling inputs)
        var requestData = form.serialize();
        // disable all inputs
        form.find('input, select, textarea, button').prop('disabled', true);
        // show spinner
        form.find('.spinner').css('visibility', 'visible');
        // post data
        jQuery.post(comby.ajaxurl, requestData, function(data) {
            if (data == "") {
                window.location.href = './admin.php?page=comby-menu-registrations&rid=' + rid + '&t=' + t;
            } else {
                alert(data);
            }
        });
        // prevent form submit
        e.preventDefault();
    });

    // save changes to registration entry
    jQuery('#comby_add-attendee-additional-event').click(function (e) {
        // get form
        var form = jQuery(this).parents('form:first');
        // get target event id and timestamp
        var eid = form.find('input[name="comby_event-select"]:checked').val();
        var t = form.find('input[name=timestamp]').val();
        // get data (before disabling inputs)
        var requestData = form.serialize();
        // disable all inputs
        form.find('input, select, textarea, button').prop('disabled', true);
        // show spinner
        form.find('.spinner').css('visibility', 'visible');
        // post data
        jQuery.post(comby.ajaxurl, requestData, function(data) {
            if (data.error) {
                console.log('ERROR!', data);
            }
            window.location.href = './admin.php?page=comby-menu-registrations&eid=' + eid + '&t=' + t + '&cmsg[]=' + data.messages.join('&cmsg[]=');
        }, 'json');
        // prevent form submit
        e.preventDefault();
    });
    jQuery('.comby_add_attendee_to_additional_event_form input[type=radio], .comby_add_attendee_to_additional_event_form input[type=checkbox], .comby_add_attendee_to_additional_event_form select').on('change', function (e) {
        if (jQuery('.comby_add_attendee_to_additional_event_form input[name="comby_event-select"]:checked').val() &&
            jQuery('.comby_add_attendee_to_additional_event_form input[name="comby_attendees[]"]')[0].checked &&
            ((jQuery('.comby_add_attendee_to_additional_event_form input[name="comby_email_confirmation"]')[0].checked &&
            jQuery('.comby_add_attendee_to_additional_event_form select[name="comby_sendmail_form"]').val()) ||
            !jQuery('.comby_add_attendee_to_additional_event_form input[name="comby_email_confirmation"]')[0].checked)) {
            jQuery('.comby_add_attendee_to_additional_event_form button[type=submit]').prop('disabled', false);
        } else {
            jQuery('.comby_add_attendee_to_additional_event_form button[type=submit]').prop('disabled', true);
        }
    })

    // select text when shortcode input is clicked
    jQuery('.comby-shortcode').click(function () { jQuery(this).select(); } );

    // autocomplete
    jQuery('.comby-autocomplete__input').focus( function () {
        comby_autocomplete(jQuery(this).parents('.comby-autocomplete:first'));
    } );
    jQuery('.comby-autocomplete__input').keyup(delay( function () {
        comby_autocomplete(jQuery(this).parents('.comby-autocomplete:first'));
    }, 350) );
    jQuery('.comby-autocomplete__input').change( function () {
        // set hidden input to new value
        jQuery(jQuery(this).data('target')).val('link:' + jQuery(this).val());
    });
    jQuery('.comby-autocomplete__input').blur(delay( function () {
        comby_disable_autocomplete(jQuery(this).parents('.comby-autocomplete:first'))
    }, 50 ) );

    jQuery('.comby-register-form input, .comby-register-form select').change(function () {
        comby_update_form_state();
    });
    jQuery('.comby-register-form input').keyup(function () {
        comby_update_form_state();
    });

    comby_update_form_state();

    jQuery('.comby-deleteattendee').click(function () {
        jQuery(this).parent().parent().parent().remove();
    });
    jQuery('#comby-registration-add-attendee').click(function () {
        var newatt = jQuery('.comby-attendee-list .comby-clone').clone();
        newatt.removeClass('comby-clone');
        var attcountidx = parseInt(jQuery('#comby_registration_attcountidx_id').val());
        newatt.html(newatt.html().replace(/attidx/g, attcountidx));
        newatt.insertBefore(jQuery('.comby-attendee-list table tr:last'));
        jQuery('#comby_registration_attcountidx_id').val(++attcountidx);
    });

    jQuery('.comby_settings_tab').click(function () {
        // switch 'current' tab
        var tabgroup = jQuery(this).data('tabgroup');
        jQuery(".comby_settings_tab[data-tabgroup='" + tabgroup + "']").removeClass('current');
        jQuery(this).addClass('current');
    });

    jQuery('.comby-downloadbutton').click(function () {
        const eid = jQuery(this).data('event');
        const download = jQuery(this).val();
        jQuery.ajax({
            url: comby.ajaxurl,
            method: 'POST',
            async: false,
            data: { action: 'comby_download', eid: eid, download: download },
            success: function(data) {
                window.open(data);
            },
        });
    });

    jQuery('#comby-button-registration-form').on('click', function () {
        jQuery('#comby-button-registration-form-dropdown').slideToggle(200);
    });
});

function comby_update_form_state() {
    // check required checkboxes
    var formvalid = true;
    jQuery('.comby-register-form input[type=checkbox]').each(function (i) {
        if (jQuery(this).data('required') == 'required' && !jQuery(this).prop('checked')) {
            formvalid = false;
        }
    });
    // check required fields
    jQuery('.comby-register-form input[type=email]:required').each(function (i) {
        var mailvalue = jQuery(this).val();
        if (!validateEmail(mailvalue)) {
            formvalid = false;
        }
    });
    jQuery('.comby-register-form input[type=text]:required').each(function (i) {
        var textvalue = jQuery(this).val();
        if (textvalue == "") {
            formvalid = false;
        }
    });
    jQuery('.comby-register-form select:required').each(function (i) {
        var selectvalue = jQuery(this).val();
        if (selectvalue == "") {
            formvalid = false;
        }
    });

    jQuery('.comby-register-form .comby-submit').prop('disabled', !formvalid);
}

function validateEmail(email) {
    var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
}

function comby_update_event_admin_page() {
    if (jQuery('#comby_event_type_id').val() == "continuously") {
        jQuery('.comby-eventtype-continuously').slideDown(200);
        jQuery('.comby-eventtype-dates').slideUp(200);
    } else {
        jQuery('.comby-eventtype-continuously').slideUp(200);
        jQuery('.comby-eventtype-dates').slideDown(200);
    }
}

function comby_init_event_datepicker( elements, secondaryfields ) {
    elements.datepicker({
        dateFormat: 'dd.mm.yy',
    });

    // set secondary date fields to same date if empty or previous date was identically
    if (secondaryfields) {
        elements.parent().find('.comby-event-startdate').datepicker("option", {
            onSelect: function (date, instance) {
                jQuery(this).parent().parent().find(secondaryfields).each(function () {
                    if ( jQuery(this).val() == "" || jQuery(this).val() == instance.lastVal)
                        jQuery(this).datepicker("setDate", date);
                });
            },
        });
    }
}

function comby_autocomplete(parent) {
    var resultdiv = parent.find('.comby-autocomplete__values');
    var input = parent.find('.comby-autocomplete__input:first');
    var inputval = input.val();
    // get value of hidden field
    var hiddeninput = jQuery(input.data('target')).val();
    // autocomplete list of pages
    jQuery.post(comby.ajaxurl, { action: 'comby_autocompletepages', searchterm: inputval, value: hiddeninput }, function(data) {
        try {
            var ret = JSON.parse(data);
            resultdiv.html("");
            parent.find('.comby-autocomplete__link').html("");
            parent.find('.comby-autocomplete__link-wrapper').hide();
            parent.find('.comby-autocomplete__pages-wrapper').hide();
            // add current value as entry in dropdown
            if (inputval != "") {
                parent.find('.comby-autocomplete__link').append('<p class="comby-autocomplete-entry" data-type="link" data-value="' + inputval + '">' + inputval + '</p>');
                parent.find('.comby-autocomplete__link-wrapper').show();
            }
            if (ret.pages.length > 0)
                parent.find('.comby-autocomplete__pages-wrapper').show();
            ret.pages.forEach(function (page) {
                resultdiv.append('<p class="comby-autocomplete-entry" data-type="page" data-value="' + page.ID + '">' + page.post_title + '</p>')
            });
            // update click events on entries
            parent.find('.comby-autocomplete-entry').click( function () {
                jQuery(input.data('target')).val(jQuery(this).data('type') + ':' + jQuery(this).data('value'));
                input.val(jQuery(this).html());
            });
        } catch (e) {
            // unknown error
            alert(data);
        }
        parent.find('.comby-autocomplete__wrapper').addClass('comby-autocomplete__wrapper--active');
    });
}

function comby_disable_autocomplete(parent) {
    parent.find('.comby-autocomplete__wrapper').removeClass('comby-autocomplete__wrapper--active');
}
